var map = {
	"./de/triangleIcon.png": "ZVet",
	"./en/triangleIcon.png": "xEvi",
	"./es/triangleIcon.png": "16AT",
	"./fr/triangleIcon.png": "hhSQ",
	"./ja/triangleIcon.png": "XNtE",
	"./ko/triangleIcon.png": "a9xk",
	"./pt/triangleIcon.png": "GfXE",
	"./ru/triangleIcon.png": "+Yy5",
	"./tc/triangleIcon.png": "n5KH",
	"./th/triangleIcon.png": "UWMD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HneJ";